import type { GenericError } from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';
import messages from './messages.tsx';

export const FETCH_LINKED_SPACES_FAILURE =
	'state.actions.fetch-linked-spaces-failure.FETCH_LINKED_SPACES_FAILURE';

export type FetchLinkedSpacesFailureAction = {
	type: typeof FETCH_LINKED_SPACES_FAILURE;
	payload: GenericError;
};

export const fetchLinkedSpacesFailure = (): FetchLinkedSpacesFailureAction => ({
	type: FETCH_LINKED_SPACES_FAILURE,
	payload: {
		error: {
			message: messages.genericMessage,
			header: messages.genericHeader,
		},
	},
});
